import { authHeader } from 'services';
import { Api } from './api/axios.service';

const getTutorList = (
  page: number,
  amount: number,
  filter: string,
) => {
  return Api.get(
    `tutor?page=${page}&amount=${amount}&filter=${filter}`,
    {
      headers: authHeader(),
    }
  );
};

const getTutorMaxPage = (amount: number, filter: string) => {
  return Api.get(
    `tutor?amount=${amount}&filter=${filter}`,
    {
      headers: authHeader(),
    }
  );
};

const disableTutor = (cpf: string, active: boolean) => {
  return Api.put(`/tutor/disable/${cpf}`, {
    active
  }, {
    headers: authHeader(),
  }).then((response) => response);
};

const getPlansTutor = (id: string) => {
  return Api.get(`/tutor-plan/${id}`,
  {
    headers: authHeader(),
  });
};

const getCurrentUser = () => {
  return Api.get('/user', {
    headers: authHeader(),
  });
};

export const TutorService = {
  getTutorList,
  getTutorMaxPage,
  getCurrentUser,
  disableTutor,
  getPlansTutor,
};
